import {getPageAlignedDataOffset} from './getPageAlignedDataOffset';

export function getInfiniteScrollBoundaryOffset(
  dataLength: number,
  scrollAttemptedOffset?: number
): number {
  return Math.max(getPageAlignedDataOffset(dataLength), scrollAttemptedOffset ?? 0);
}
